import React from 'react';
import './ExpirationPulse.css';

interface ExpirationPulseProps {
  isVisible: boolean;
  position: { x: number; y: number };
}

const ExpirationPulse: React.FC<ExpirationPulseProps> = ({ isVisible, position }) => {
  if (!isVisible) return null;

  return (
    <div
      className="expiration-pulse"
      style={{
        left: position.x,
        top: position.y,
        transform: 'translate(-50%, -50%)'
      }}
    />
  );
};

export default ExpirationPulse; 